const handleClick = (e) => {
    const target = e.currentTarget;

    closeOtherDropdowns(target);
    target.classList.toggle('list-page-links__button--active');
}

const closeOtherDropdowns = (target) => {
    const dropdownContainers = [...document.querySelectorAll('.list-page-links__container .list-page-links__list--active')].map(x => x.parentElement);
    dropdownContainers.forEach(container => {
        if (container.isSameNode(target.parentElement))
            return;
        const button = container.querySelector('.list-page-links__button');
        button.classList.remove('list-page-links__button--active');
    });
}

const init = () => {
    const dropdownButtons = [...document.querySelectorAll('.list-page-links__button')];
    dropdownButtons.forEach(button => {
        button.addEventListener('click', handleClick);
    });
}

const closeDropdowns = (e) => {
    if (e.target.classList.contains('list-page-links__button'))
        return;
    //class starts with list-page-links and ends with --active
    const dropdowns = [...document.querySelectorAll('[class^=list-page-links][class$=--active]')];
    dropdowns.forEach(dropdown => {
        const classToToggle = dropdown.classList.contains('list-page-links__list') ? 'list-page-links__list--active' : 'list-page-links__button--active';
        dropdown.classList.remove(classToToggle);
    });
}

document.addEventListener('DOMContentLoaded', init);
document.addEventListener('click', closeDropdowns);
